import { cap1stChar } from "./CommonUtils"
import { getAayuCardActivityDatetime } from "./DateTimeUtils"

export function reformatLocationString(flatBuilding, locality) {
    var reformattedLocation = ''
    const flatBuildingSplit = flatBuilding?.split(',')
    if (flatBuildingSplit?.[0])
        reformattedLocation = cap1stChar(flatBuildingSplit[0])
    if (flatBuildingSplit?.[1])
        if (flatBuildingSplit[1][0] == ' ')
            reformattedLocation = reformattedLocation + ',' + flatBuildingSplit[1]
        else reformattedLocation = reformattedLocation + ', ' + flatBuildingSplit[1]
    if (locality && reformattedLocation) {
        reformattedLocation = reformattedLocation + ', ' + locality
    } else if (locality) {
        reformattedLocation = locality
    }
    return reformattedLocation
}

export function createEconsultPaymentWithSubscriptionData(userDetails, subscriptionData, servicePrams, serviceTokenV2, walletBalance) {
    return {
        subscriptionData: {
            userName: userDetails['name'],
            plan: subscriptionData['plan'],
            maxConsultations: subscriptionData['maxConsultations'],
            consultCount: subscriptionData['consultedCount'],
            consultLeft: subscriptionData['maxConsultations'] - subscriptionData['consultedCount'],
            validFromDate: getAayuCardActivityDatetime(subscriptionData['addedOn']),
            validTillDate: getAayuCardActivityDatetime(subscriptionData['validTill'])
        },
        memberName: servicePrams.memberName,
        memberId: servicePrams.memberId,
        memberGender: '',
        serviceToken: serviceTokenV2,
        walletBalance: walletBalance,
        consultationHashcode: servicePrams.consultationHashcode,
        phoneNumber: servicePrams.phoneNumber,
        consultationId: servicePrams.consultationId,
        caseCode: servicePrams.caseCode
    }
}